import adserver, { AxiosError } from 'services/adserver';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { monitoringKeys } from './monitoring.keys';
import {
  MonitoringCodesTree,
  NormalizedMonitoringDataNodeCodesArray,
} from './monitoring.types';
import { normalizeApiNodeToTreeNode } from './monitoring.helpers';

const getCampaignCodes = async (
  campaignId: number,
): Promise<MonitoringCodesTree> => {
  const { data } = await adserver({
    url: `/campaign/${campaignId}/monitoring/codes`,
    headers: {},
  });

  return data;
};

const toTreeData = (
  data: MonitoringCodesTree,
): NormalizedMonitoringDataNodeCodesArray => ({
  available: normalizeApiNodeToTreeNode(data.available),
  assigned: normalizeApiNodeToTreeNode(data.assigned),
});

export const useGetCampaignCodes = (
  campaignId: number,
  enabled = true,
): UseQueryResult<NormalizedMonitoringDataNodeCodesArray, AxiosError> => {
  return useQuery<
    MonitoringCodesTree,
    AxiosError,
    NormalizedMonitoringDataNodeCodesArray
  >({
    queryKey: monitoringKeys.campaignCodes(campaignId),
    queryFn: () => getCampaignCodes(campaignId),
    enabled: !!campaignId && enabled,
    select: toTreeData,
  });
};
